module.exports = __webpack_public_path__ + "static/media/cigarettes_03_thumb.f7188076.png";